export const environment = {
    production: false,
    restApiUrl: 'https://thepeoplespoll.co.uk/api/mobile/v1',
};
